import React from "react"

import { Outlet } from "react-router-dom"
import "../SettingStack/root.css"


function PublicRootLayer(){
    return(
        <div className="col-md-12">
            <h1>jroewre</h1>
            <div className='outlet__root'>
                <Outlet/>
            </div>
        </div>
    )
}

export default PublicRootLayer